import getConfig from 'next/config'

const {
  publicRuntimeConfig: { PUBLIC_PAGES_URL }
} = getConfig()

export function landingPage(language: string, restaurantId: string, bookingUuid: string): string {
  return `${PUBLIC_PAGES_URL}/${language}/restaurants/${restaurantId}/bookings/${bookingUuid}`
}
